import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { DeliverableOrMilestoneType } from 'lib/api_ts/continuosReportingApi';
import { DeliverableType, getDeliverableByProjectIdAndDeliverableId, StreamType } from 'lib/api_ts/overviewApi';
import { TaskStatusType, UserForResponsibleType } from 'lib/api_ts/responsibleApi';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom-v5-compat';

interface ContinuosReportingDeliverableUpdateFormProps {
	data: DeliverableOrMilestoneType;
	isModalOpen: boolean;
	streams: StreamType[];
	possibleResponsibles: UserForResponsibleType[];
	taskStatus: TaskStatusType[];
}

const ContinuosReportingDeliverableUpdateForm: React.FC<ContinuosReportingDeliverableUpdateFormProps> = ({
	data,
	isModalOpen,
	streams,
	possibleResponsibles,
	taskStatus,
}) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];
	const [isLoading, setIsLoading] = useState(true);
	const [selectedDeliverable, setSelectedDeliverable] = useState<DeliverableType>();

	const selectedStream = streams?.find((stream) => stream.id === selectedDeliverable?.wpStreamId);

	const responsibleUser = possibleResponsibles?.find((responsible) => responsible.id === selectedDeliverable?.responsible);

	const responsibleValue = `${responsibleUser?.firstName} ${responsibleUser?.lastName} (${responsibleUser?.email})`;

	useEffect(() => {
		if (!isModalOpen) return;
		(async () => {
			try {
				const deliverableFromAPi = await getDeliverableByProjectIdAndDeliverableId(projectId, data.id);
				setSelectedDeliverable(deliverableFromAPi);
				setIsLoading(false);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		})();
	}, [data.id, projectId, isModalOpen]);

	const fields = [
		{
			label: 'N. Deliverable',
			name: 'number',
			value: selectedDeliverable?.number,
		},
		{
			label: 'Titolo',
			name: 'title',
			value: selectedDeliverable?.title,
		},
		{
			label: 'Descrizione',
			name: 'description',
			value: selectedDeliverable?.description || 'N.D.',
		},
		{
			label: 'WP di riferimento',
			name: 'wpStreamId',
			value: selectedStream ? `${selectedStream.streamId} - ${selectedStream.name}` : '',
			//   value: selectedDeliverable?.description || "N.D.",
		},
		{
			label: 'Responsabile',
			name: 'responsible',
			value: responsibleValue,
			//   value: selectedDeliverable?.description || "N.D.",
		},
		{
			label: 'Tipologia',
			name: 'type',
			value: selectedDeliverable?.type,
		},
		// {
		//   label: "Doc. probatoria",
		//   name: "documents",
		//   value: selectedDeliverable?.probativeDocumentation,
		//   //   value: selectedDeliverable?.description || "N.D.",
		// },
		// {
		//   label: "Completata",
		//   name: "completed",
		//   value: selectedDeliverable?.completed ? "Sì" : "No",
		// },

		{
			label: 'Data prevista',
			name: 'forecastDate',
			value: selectedDeliverable?.forecastDate
				? format(selectedDeliverable?.forecastDate, 'dd/MM/yyyy', {
						locale: it,
					})
				: '',
		},
		{
			label: 'Data effettiva',
			name: 'effectiveDate',
			value: selectedDeliverable?.effectiveDate
				? format(selectedDeliverable?.effectiveDate, 'dd/MM/yyyy', {
						locale: it,
					})
				: '',
		},
		{
			label: 'Status',
			name: 'status',
			value: (() => {
				if (selectedDeliverable && taskStatus) {
					const status = taskStatus.find((status) => status.code === selectedDeliverable.status);
					return status ? status.name : '';
				}
			})(),
		},

		...(selectedDeliverable?.note
			? [
					{
						label: 'Note',
						name: 'note',
						type: 'text',
						fullWidth: true,
						value: selectedDeliverable.note,
					},
				]
			: []),
	];

	return isLoading ? (
		<div className="text-center my-4">
			<Spinner animation="border" role="status" />
		</div>
	) : (
		<Form>
			<Row>
				{fields.map((field) => {
					return (
						<Form.Group key={field.name} as={Col} md={field.fullWidth ? 12 : 6} className="pe-2 mb-3" style={{ marginTop: '2rem' }}>
							<Form.Label className="mb-3">{field.label}</Form.Label>
							<Form.Text as="p">{field.value}</Form.Text>
						</Form.Group>
					);
				})}
			</Row>
		</Form>
	);
};

export default ContinuosReportingDeliverableUpdateForm;
